import { render } from "./IconArrowTopRightOnSquare.vue?vue&type=template&id=440f6b1d"
import script from "./IconArrowTopRightOnSquare.vue?vue&type=script&lang=js"
export * from "./IconArrowTopRightOnSquare.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__